import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {BaseApi} from "../../services/BaseApi";
import {Resource} from "../model/resource";
import {HttpClient} from "@angular/common/http";
import {Session} from "../../services/session";
import {Store} from "@ngrx/store";
import {AppState} from "../../actions/reducers";
import {catchError, map} from "rxjs/operators";
import {ResourceType} from "../model/resource-type";

export interface ResourceTypeUpate {
  name: string,
}

@Injectable()
export class ResourceTypesApi extends BaseApi {
  constructor(protected http: HttpClient, protected session: Session, protected store: Store<AppState>) {
    super(http, session, store);
  }

  public getAll(): Observable<ResourceType[]> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-type`;
    return this.http
      .get(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => {
          return (<any>response).map(ResourceType.fromJson);
        }),
      )
  }

  getById(id: string): Observable<ResourceType> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-type/${id}`;
    return this.http
      .get(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => ResourceType.fromJson(response)),
      )
  }

  update(id: string, resource: ResourceTypeUpate): Observable<any> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-type/${id}`;
    return this.http
      .put(url, resource, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => Resource.fromJson(response))
      )
  }

  create(resource: ResourceTypeUpate): Observable<Resource> {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-type`;
    return this.http
      .post(url, resource, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
        map(response => Resource.fromJson(response))
      )
  }

  delete(id: string) {
    let serviceProvider = this.getServiceProviderIdentifier();
    let url = `/api/v2/tyrael/sp/${serviceProvider}/resource-type/${id}`;
    return this.http
      .delete(url, {headers: this.getHeaders()})
      .pipe(
        catchError(err => this.handleNetworkError(err)),
      )
  }
}
